module.exports = __webpack_public_path__ + "img/jili_logo.eb1dfc87.png";